import React from 'react';

import { BREAKPOINTS, disabledColor, unit } from '@zego/theme';

import H2 from '@zego/components/atoms/H2';
import RegularText from '@zego/components/atoms/RegularText';
import Spacer from '@zego/components/atoms/Spacer';
import ContentContainer from '@zego/components/ContentContainer';
import SectionDisplay from '@zego/components/SectionDisplay';

const FleetZegoReview = ({ text }) => (
  <SectionDisplay css={{ backgroundColor: disabledColor(2) }}>
    <ContentContainer
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <H2
        css={{
          textAlign: 'center',
          marginBottom: unit(2),
          fontSize: '32px',
          lineHeight: '40px',
          [BREAKPOINTS.medium]: {
            marginBottom: unit(3),
            fontSize: '32px',
          },
        }}
      >
        {text.quote}
      </H2>
      <Spacer height={unit(2)} />
      <RegularText css={{ textAlign: 'center' }}>{text.reviewer}</RegularText>
      <Spacer height={unit(6)} />
    </ContentContainer>
  </SectionDisplay>
);

export default FleetZegoReview;
